/**
 * Vuex module — flujo factoring (anticipo de facturas).
 *
 * Estado central del flujo BeforeFacture (y descendientes que se irán
 * extrayendo en commits posteriores).
 *
 * Commit 5: introducido como BRIDGE para `flowStep`.
 * Commit 12: se incorpora el tracking de onboarding (anteriormente vivía como
 * métodos en BeforeFacture.vue). Las actions `iniciarFlow` y `registrarPaso`
 * leen `businesSelected` e `ip` desde rootState — no se duplica esa data acá.
 */

import { Module } from "vuex";
import { FlowStep } from "@/domain/factoring/types";
import * as TrackingApi from "@/services/api/factoring/tracking.api";

const ORIGEN = "AnticipoFactura";

export interface FactoringState {
	flowStep: FlowStep;
	ultimoPaso: any | null;
}

const initialState = (): FactoringState => ({
	flowStep: "loading",
	ultimoPaso: null,
});

const factoringModule: Module<FactoringState, any> = {
	namespaced: true,
	state: initialState(),
	mutations: {
		setFlowStep(state, step: FlowStep) {
			state.flowStep = step;
		},
		setUltimoPaso(state, payload: any) {
			state.ultimoPaso = payload;
		},
		reset(state) {
			Object.assign(state, initialState());
		},
	},
	actions: {
		goToStep({ commit }, step: FlowStep) {
			commit("setFlowStep", step);
		},

		/**
		 * Carga el último paso registrado para la empresa seleccionada.
		 * Llamada al entrar al flujo de anticipo.
		 */
		async iniciarFlow({ commit, rootState }) {
			const empresa = rootState && rootState.businesSelected;
			if (!empresa || !empresa.id) return;
			try {
				const res: any = await TrackingApi.ultimoPasoEmpresa(empresa.id, ORIGEN);
				commit("setUltimoPaso", (res && res.data) || null);
			} catch (e) {
				commit("setUltimoPaso", null);
			}
		},

		/**
		 * Registra un paso del onboarding. `info` y `facturas` son payloads
		 * libres definidos por el caller.
		 */
		registrarPaso({ rootState }, { variable, info, facturas }: { variable: string; info: any; facturas: any }) {
			const empresa = rootState && rootState.businesSelected;
			const ip = rootState && rootState.ip;
			if (!empresa || !empresa.id) return Promise.resolve();
			return TrackingApi.tranckingOnboarding(ORIGEN, empresa.id, ip, variable, info, facturas);
		},
	},
};

export default factoringModule;
